// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 5,
  argument: "An exhortation to fly unlawful lust, and the occasions of it.",
  verses: [
    { n: 1, text: "My son, attend to my wisdom, and incline thy ear to my prudence," },
    { n: 2, text: "That thou mayst keep thoughts, and thy lips may preserve instruction. Mind not the deceit of a woman." },
    { n: 3, text: "For the lips of a harlot are like a honeycomb dropping, and her throat is smoother than oil." },
    { n: 4, text: "But her end is bitter as wormwood, and sharp as a two-edged sword." },
    { n: 5, text: "Her feet go down into death, and her steps go in as far as hell." },
    { n: 6, text: "They walk not by the path of life, her steps are wandering, and unaccountable." },
    { n: 7, text: "Now, therefore, my son, hear me, and depart not from the words of my mouth." },
    { n: 8, text: "Remove thy way far from her, and come not nigh the doors of her house." },
    { n: 9, text: "Give not thy honour to strangers, and thy years to the cruel." },
    { n: 10, text: "Lest strangers be filled with thy strength, and thy labours be in another man's house," },
    { n: 11, text: "And thou mourn at the last, when thou shalt have spent thy flesh and thy body, and say;" },
    { n: 12, text: "Why have I hated instruction, and my heart consented not to reproof," },
    { n: 13, text: "And have not heard the voice of them that taught me, and have not inclined my ear to masters?" },
    { n: 14, text: "I have almost been in all evil, in the midst of the church and of the congregation." },
    { n: 15, text: "Drink water out of thy own cistern, and the streams of thy own well:" },
    { n: 16, text: "Let thy fountains be conveyed abroad, and in the streets divide thy waters." },
    { n: 17, text: "Keep them to thyself alone, neither let strangers be partakers with thee." },
    { n: 18, text: "Let thy vein be blessed, and rejoice with the wife of thy youth:" },
    { n: 19, text: "Let her be thy dearest hind, and most agreeable fawn: let her breasts inebriate thee at all times: be thou delighted continually with her love." },
    { n: 20, text: "Why art thou seduced, my son, by a strange woman, and art cherished in the bosom of another?" },
    { n: 21, text: "The Lord beholdeth the ways of man, and considereth all his steps." },
    { n: 22, text: "His own iniquities catch the wicked, and he is fast bound with the ropes of his own sins." },
    { n: 23, text: "He shall die, because he hath not received instruction, and in the multitude of his folly he shall be deceived." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Thoughts. Or wisdom; and act with discretion. — Mind, &c., is omitted in Hebrew and St. Jerome. (Calmet) — By woman all concupiscence, or the inducement to sin, is commonly understood. We must not think of such things.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Sword. \"It is a crime even to hearken.\" (St. Ambrose, de Abrah. ii. 11.) She seeks thy ruin,", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: ", and chap. ii. 16.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "They. Hebrew, \"if perhaps thou ponder the path of life.\" (Pagnin) (Haydock) — Or \"she ponders not,\" &c. She walks inconsiderately, and consults only her passions, chap. vii. 10. (Calmet) — No one can depend on her love.", attribution: "Menochius" }
    ] },
    { verse: 9, notes: [
      { text: "Strangers. The world, the flesh, and the devil are such; cruelly devising our ruin.", attribution: "Worthington" }
    ] },
    { verse: 10, notes: [
      { text: "Strength. Or children,", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: ", and Genesis xlix. 3.", attribution: "Calmet" }
    ] },
    { verse: 11, notes: [
      { text: "Body. He alludes to a shameful disease, the just punishment of intemperance, Ecclesiasticus xix. 3.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Evil. Infirm and worn out, having lost my reputation, &c. (Calmet) — Though I lived among the faithful, I was under no restraint.", attribution: "Menochius" }
    ] },
    { verse: 15, notes: [
      { text: "Well. Live comfortably on your own property, (Cajetan) with your own wife.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Thee. Stick to thy own wife. In a moral sense, let those who instruct others, take care not to neglect themselves.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Vein. Thou shalt have a numerous progeny, Psalm lxvii. 28., and Isaias xlviii. 1.", attribution: "Calmet" }
    ] },
    { verse: 19, notes: [
      { text: "Love. This is spoken by way of permission, and to withdraw people from unlawful connections, Ecclesiastes ii. 1., and 1 Corinthians vii. 29.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Ropes. \"Evil habits unrestrained induce a necessity,\" (St. Augustine, Confessions viii. 5.) though not absolute. (Haydock) — The libertine thinks he can get free as soon as he pleases; not being aware of the chains which he is forging for himself. (Calmet) — Sin requires punishment.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
